// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.start_error {
  position: relative;
}
.start_error .btn-start-exam {
  color: #CB3F3F;
  border: 1px solid #CB3F3F;
  background-color: #FFEFEF;
}
.start_error .bg_lightRed {
  background-color: #FFDCDC;
}
.start_error .border_lightRed {
  border: 1px solid #FFD6D6;
  background-color: #FFFBFB;
}
.start_error .font_16 {
  font-size: 16px;
}
.start_error .font_14 {
  font-size: 14px;
}
.start_error .color_yash {
  color: #707070;
}
.start_error .color_333 {
  color: #333333;
}
.start_error .color_green {
  color: #00C596;
}
.start_error .custom-cursor {
  cursor: pointer;
}
.start_error .button_bg_lightgreen {
  background-color: #E1FFF8;
  border: 1px solid #8EFFE4;
  padding: 10px;
  margin-top: 25px;
  font-weight: bold;
  border-radius: 5px;
  color: #00C596;
}
.start_error .bg_lightGreen {
  background-color: #F2F5F8;
  border-radius: 5px;
  padding: 6px;
}
.start_error .bg_darkYash {
  background-color: #D8D8D8;
  border-radius: 5px;
  padding: 5px;
}
.start_error .border_green {
  border: 1px solid #00C596;
  padding: 10px;
  border-radius: 5px;
  height: 15.9em;
}
.start_error .border_green img {
  display: block;
  margin-right: auto;
  margin-left: auto;
  margin-top: 2em;
}`, "",{"version":3,"sources":["webpack://./src/student_module/components/learn_practice/start_error_exam/_startErrorExam.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;AACI;EACI,cAAA;EACA,yBAAA;EACA,yBAAA;AACR;AAEI;EACI,yBAAA;AAAR;AAGI;EACI,yBAAA;EACA,yBAAA;AADR;AAII;EACI,eAAA;AAFR;AAKI;EACI,eAAA;AAHR;AAMI;EACI,cAAA;AAJR;AAOI;EACI,cAAA;AALR;AAQI;EACI,cAAA;AANR;AASI;EACI,eAAA;AAPR;AAUI;EACI,yBAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AARR;AAWI;EACI,yBAAA;EACA,kBAAA;EACA,YAAA;AATR;AAYI;EACI,yBAAA;EACA,kBAAA;EACA,YAAA;AAVR;AAaI;EACI,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;AAXR;AAcI;EACI,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAZR","sourcesContent":[".start_error {\n    position: relative;\n\n    .btn-start-exam {\n        color: #CB3F3F;\n        border: 1px solid #CB3F3F;\n        background-color: #FFEFEF;\n    }\n\n    .bg_lightRed {\n        background-color: #FFDCDC;\n    }\n\n    .border_lightRed {\n        border: 1px solid #FFD6D6;\n        background-color: #FFFBFB;\n    }\n\n    .font_16 {\n        font-size: 16px;\n    }\n\n    .font_14 {\n        font-size: 14px;\n    }\n\n    .color_yash {\n        color: #707070;\n    }\n\n    .color_333 {\n        color: #333333;\n    }\n\n    .color_green {\n        color: #00C596;\n    }\n\n    .custom-cursor {\n        cursor: pointer;\n    }\n\n    .button_bg_lightgreen {\n        background-color: #E1FFF8;\n        border: 1px solid #8EFFE4;\n        padding: 10px;\n        margin-top: 25px;\n        font-weight: bold;\n        border-radius: 5px;\n        color: #00C596;\n    }\n\n    .bg_lightGreen {\n        background-color: #F2F5F8;\n        border-radius: 5px;\n        padding: 6px;\n    }\n\n    .bg_darkYash {\n        background-color: #D8D8D8;\n        border-radius: 5px;\n        padding: 5px;\n    }\n\n    .border_green {\n        border: 1px solid #00C596;\n        padding: 10px;\n        border-radius: 5px;\n        height: 15.9em;\n    }\n\n    .border_green img {\n        display: block;\n        margin-right: auto;\n        margin-left: auto;\n        margin-top: 2em;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
